import React from 'react';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export const LanguageToggle = ({ language, setLanguage }) => {
  return (
    <Button
      onClick={() => setLanguage(language === 'en' ? 'gu' : 'en')}
      variant="outline"
      className="flex items-center gap-2 border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-all duration-300"
    >
      <Globe className="h-4 w-4" />
      {language === 'en' ? 'ગુજરાતી' : 'English'}
    </Button>
  );
};